<template>
  <el-button v-bind="$attrs" v-on="$listeners">
    <slot />
  </el-button>
</template>

<script>
export default {
  name: "hm-button",
  data() {
    return {};
  },
  props: {},
  created() {},
  mounted() {},
  computed: {},
  methods: {},
  watch: {},
};
</script>

<style scoped lang='less'>
.el-button {
  font-size: 14px;
  color: #fff;
  border-radius: 8px;
  border: none;
  background: #1d63fd;
}
.el-button:hover{
    background: #0000ff;
}
</style>



// WEBPACK FOOTER //
// src/components/baseComponents/hm-button.vue